var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes,style:(_vm.cssVariables),attrs:{"id":_vm.$attrs.id},on:{"click":_vm.onClick}},[_c('div',{staticClass:"cr-btn__content"},[_vm._t("default")],2),(_vm.loading)?_c('div',{staticClass:"cr-btn__loader"},[_c('CRProgressCircular',{attrs:{"size":_vm.loadingSize,"color":_vm.computedTextColor}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }